import { FeaturesCommonConfig } from "../config";


export const featuresCommon: FeaturesCommonConfig = {
  appVersion: "1.0.0",
  baseURL: "https://b2b-app.dev-gcp.fena.co",
  database: {
    url: process.env.DATABASE_URL || "",
  },
  github: {
    githubAccessToken: process.env.GITHUB_ACCESS_TOKEN || "",
  },

  zapier: {
    webhookUrl: "https://hooks.zapier.com/hooks/catch/10834551/uexm3gs",
    filterFenaEmails: true,
    toolkitAdminCompanyUrl: `https://admin.prod-gcp.fena.co/private/companies/details/:id`,
  },
  app: {
    appName: process.env.APP_NAME ?? "fena-b2b-app",
    scopes: process.env.SCOPES?.split(",") || [],
    fenaMainUrl: process.env.FENA_MAIN_URL || "",
    fenaFrontendUrl: process.env.FENA_FRONTEND_URL || "",
    fenaAppKey: process.env.FENA_APP_KEY || "",
    publicConnectionKey: process.env.PUBLIC_CONNECTION_KEY || "",

    apiKey: process.env.SHOPIFY_API_KEY || "",
    apiSecret: process.env.SHOPIFY_API_SECRET || "",

    fenaWholesaleCustomerBlockId:
      process.env.SHOPIFY_FENA_WHOLESALE_CUSTOMER_BLOCK_ID || "",
    fenaWholesaleThemeExtensionId:
      process.env.SHOPIFY_FENA_WHOLESALE_THEME_EXTENSION_ID || "",
    fenaWholesaleTierBlockId:
      process.env.SHOPIFY_FENA_WHOLESALE_TIER_BLOCK_ID || "",
    fenaWholesaleProductActionId:
      process.env.SHOPIFY_FENA_WHOLESALE_PRODUCT_ACTION_ID || "",
    fenaWholesaleTierDiscountId:
      process.env.SHOPIFY_FENA_WHOLESALE_TIER_DISCOUNT_ID || "",
    fenaCheckout1Id: process.env.SHOPIFY_FENA_CHECKOUT_1_ID || "",
    fenaWholesaleCheckoutValidationId:
      process.env.SHOPIFY_FENA_WHOLESALE_CHECKOUT_VALIDATION_ID || "",
    fenaWholesaleShippingId:
      process.env.SHOPIFY_FENA_WHOLESALE_SHIPPING_ID || "",
    fenaWholesaleShipping1Id:
      process.env.SHOPIFY_FENA_WHOLESALE_SHIPPING_1_ID || "",
    cartCheckoutValidation1Id:
      process.env.SHOPIFY_CART_CHECKOUT_VALIDATION1_ID || "",
    fenaWholesaleCartTransformId:
      process.env.SHOPIFY_FENA_WHOLESALE_CART_TRANSFORM_ID || "",
    fenaB2bOptionsId: process.env.SHOPIFY_FENA_B2B_OPTIONS_ID || "",
    bundleConfigExtensionId:
      process.env.SHOPIFY_BUNDLE_CONFIG_EXTENSION_ID || "",

    fenaPublicKey: process.env.SHOPIFY_B2B_APP_PUBLIC_KEY || "",
    fenaPrivateKey: process.env.SHOPIFY_B2B_APP_PRIVATE_KEY || "",
  },
};
